import { render, staticRenderFns } from "./ProgramList.vue?vue&type=template&id=0a2595e8&"
import script from "./ProgramList.vue?vue&type=script&lang=js&"
export * from "./ProgramList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports